import Api from "./base.api";

interface IProjectsApi {
  fetch: (type: string) => Promise<any>;
  add: (params: { type: string; title: string }) => Promise<any>;
  edit: (params: { type: string; title: string; _id: string }) => Promise<any>;
  delete: (id: string) => Promise<any>;
  getProject: (id: string) => Promise<any>;
}

const generateQueryString = (obj: any) => {
  const keyValuePairs = Object.entries(obj).map(
    ([key, value]) => `${key}=${value}`
  );
  return keyValuePairs.join("&");
};

class ProjectsApi extends Api implements IProjectsApi {
  fetch = () => this.request("projects");

  add = (params: { type: string; title: string }) =>
    this.request("projects/add", {
      method: "post",
      body: JSON.stringify(params),
    });

  clone = (id) =>
    this.request(`projects/${id}/duplicate`, {
      method: "post",
    });

  delete = (id: string) =>
    this.request(`projects/${id}/remove`, {
      method: "delete",
    });

  edit = (params: any) =>
    this.request(`projects/${params._id}/edit`, {
      method: "post",
      body: JSON.stringify(params),
    });

  getProject = (id: string) => this.request(`projects/${id}`);

  getDistribution = (
    projectId: string,
    projectType: string,
    params: any = {}
  ) =>
    this.request(
      `projects/${projectId}/distribution?type=${projectType}&${generateQueryString(
        params
      )}`
    );
}

export default new ProjectsApi();
